module.exports = __webpack_public_path__ + "static/media/fire.3dd46c62.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/fire.mp3
// module id = 1301
// module chunks = 0